import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-campaignmonitor', 'BrandCampaignmonitor', [["path",{"d":"M3 18l9 -6.462l-9 -5.538v12h18v-12l-9 5.538"}]]);